export const DSCVRY_PARTNER_SLUG = 'dscvry';
/** Expert subtype for the DSCVRY contact list builder listing (public product language). */
export const CONTACT_LIST_BUILDER_SUBTYPE = 'Contact List Builder';
/** @deprecated Prefer CONTACT_LIST_BUILDER_SUBTYPE; kept for listings seeded before the rename. */
export const CONTACT_RESEARCH_SUBTYPE = 'Contact Research';
export const DSCVRY_HUB_URL = 'https://airtable.com/appA4hnizMi7SAm0y/shrN6pi33esu49Htc/tblK0oIS3jURkqrzX/viwyMWkbAnx62aPt1';
export const DSCVRY_REGISTER_URL = 'https://app.dscvry.co/#/register-user?type=founder';

export const DSCVRY_DESCRIPTION =
  'DSCVRY helps founders find people in a target segment and build a contact list for problem discovery. HomeCook generates the list from a venture set up in the DSCVRY Business Hub, then hands it back. This does not approve a facility, start outreach, or share financial, POS, menu, inventory, or diner data.';

/** Founder app entry. Venture steps stay in the Business Hub, not this URL alone. */
export const getDscvrySignupUrlFromEnv = (): string =>
  (process.env.REACT_APP_DSCVRY_SIGNUP_URL || DSCVRY_REGISTER_URL).trim();

export const getDscvryHubUrlFromEnv = (): string =>
  (process.env.REACT_APP_DSCVRY_HUB_URL || DSCVRY_HUB_URL).trim();

/** Optional partner webhook. Empty unless REACT_APP_DSCVRY_WEBHOOK_URL is set. Never a secret. */
export const getDscvryWebhookUrlFromEnv = (): string =>
  (process.env.REACT_APP_DSCVRY_WEBHOOK_URL || '').trim();

type HandoffResource = {
  resource_type?: string
  resource_subtype?: string
  partner_handoff?: { partner?: { slug?: string; capabilities?: string[]; hub_url?: string } }
};

const appendProjectRef = (url: string, projectId: string) => {
  if (!url || !projectId || /(?:\?|&)ref=/.test(url)) return url;
  const hashAt = url.indexOf('#');
  if (hashAt >= 0) {
    const hash = url.slice(hashAt + 1);
    return `${url.slice(0, hashAt)}#${hash}${hash.includes('?') ? '&' : '?'}ref=${encodeURIComponent(projectId)}`;
  }
  return `${url}${url.includes('?') ? '&' : '?'}ref=${encodeURIComponent(projectId)}`;
};

/** Same rule as the pantry: an app.dscvry.co link from the API is used as-is, otherwise the platform URL with the project id. */
export const platformHandoffUrl = (resource: HandoffResource | null | undefined, returnedOpenUrl: string, projectId: string): string => {
  let host = '';
  try { host = new URL(returnedOpenUrl || '').host; } catch { host = ''; }
  if (host === 'app.dscvry.co') return returnedOpenUrl;
  const platform = (resource?.partner_handoff?.partner?.hub_url || '').trim() || DSCVRY_REGISTER_URL;
  return appendProjectRef(platform, projectId);
};

export type ContactProjectSummary = {
  project_id: string
  name?: string
  owner_uid?: string
  business_id?: string
  connection_status?: string
  created?: string
  record_count: number
  active_count: number
  review_count: number
  latest_brief_id?: string
  last_generated?: string
  handed_at?: string
  imported?: boolean
};

export const projectStatusLabel = (item: ContactProjectSummary): string => {
  if (item.connection_status === 'revoked') return 'Disconnected';
  if (item.handed_at) return 'Handed off';
  return 'In progress';
};

export const formatShortDate = (value?: string): string => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

/** True when an expert listing is the DSCVRY contact list builder, including partner slug. */
export const isContactBuilderResource = (resource?: HandoffResource | null): boolean => {
  if (!resource || resource.resource_type !== 'expert') return false;
  const subtype = (resource.resource_subtype || '').trim().toLowerCase();
  const partner = resource.partner_handoff?.partner;
  return subtype === CONTACT_LIST_BUILDER_SUBTYPE.toLowerCase()
    || subtype === CONTACT_RESEARCH_SUBTYPE.toLowerCase()
    || (partner?.capabilities || []).includes('contact_research')
    || (partner?.slug || '').toLowerCase() === DSCVRY_PARTNER_SLUG;
};
